function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "abc71e73-d4d0-48d8-8443-969b5fcd59ae",
  x1: 210.01,
  y1: 811.87,
  x2: 210.01,
  y2: 341.61,
  gradientTransform: "matrix(-1, 0, 0, 1, 421, 0)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "bdd0ebe0-6a5f-4260-a4c1-52643e5fb488",
  x1: 978.5,
  y1: 806.5,
  x2: 978.5,
  y2: 315.5,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#abc71e73-d4d0-48d8-8443-969b5fcd59ae"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "growth analytics");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500.59,135.41l-15.52,9.85,9.42-17.14a15.35,15.35,0,0,0-9.38-3.35h-.25a18.09,18.09,0,0,1-3.22-.23l-5.26,3.33,2.25-4.1a18.72,18.72,0,0,1-9.2-7l-9.41,6L466,111.94c-5.5-6.6-12.92-10.66-21.09-10.66-9.79,0-18.51,5.83-24.14,14.9a18,18,0,0,1-16,8.6h-.52c-10.81,0-19.57,12.26-19.57,27.37s8.76,27.37,19.57,27.37a14.71,14.71,0,0,0,6.81-1.7c7.05-3.67,16.31-3.74,23.69-.47a24.71,24.71,0,0,0,20.14,0,28.27,28.27,0,0,1,23.47.45,14.72,14.72,0,0,0,6.75,1.67c10.81,0,19.57-12.25,19.57-27.37A34.77,34.77,0,0,0,500.59,135.41Z",
  transform: "translate(-86 -80.5)",
  fill: "#f2f2f2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M471.34,175.46a28.9,28.9,0,0,0-16.77,1.83,24.69,24.69,0,0,1-20.13,0,28.25,28.25,0,0,0-23.69.46,14.6,14.6,0,0,1-6.81,1.71c-9.61,0-17.59-9.67-19.26-22.43a18.43,18.43,0,0,0,4.8-5.18c5.63-9.07,14.35-14.89,24.14-14.89s18.41,5.75,24,14.73a18.52,18.52,0,0,0,15.95,8.76h.25C461.5,160.4,468.12,166.53,471.34,175.46Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.03
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M368.13,561.77l-6.29-3.91c-.6-.37-1.19-.77-1.79-1.15a59.86,59.86,0,0,0,6.05-116.62l.31,24.66-13.55-26.83h-.17a59.87,59.87,0,0,0-62.58,57c-.06,1.15,0,2.27,0,3.4-4.71-5.38-9-11.15-11.83-17.47-5.73-12.79-5.84-27.28-5.39-44.9.9-34.9,2.41-70.08,4.37-105.14a59.85,59.85,0,0,0,53.16-56.64c.08-1.83.05-3.63,0-5.43,0-.45,0-.89-.07-1.34-.12-1.74-.28-3.46-.55-5.16,0-.28-.1-.55-.15-.82-.24-1.44-.54-2.86-.88-4.26-.13-.53-.26-1.05-.4-1.57-.42-1.53-.88-3-1.42-4.52-.18-.49-.39-1-.58-1.46-.42-1.09-.88-2.17-1.37-3.23-.26-.56-.51-1.12-.78-1.67-.08-.14-.13-.29-.21-.43l0,0a59.84,59.84,0,0,0-70.28-30.36l.4,32.1-13.4-26.52A59.57,59.57,0,0,0,212.12,284h-.06c.09.43.22.84.32,1.26.19.79.39,1.57.61,2.35.28,1,.6,2,.93,3,.25.74.49,1.47.77,2.2.41,1.06.87,2.09,1.33,3.12.27.6.51,1.22.8,1.81q1.14,2.32,2.48,4.53c.31.52.66,1,1,1.51.64,1,1.28,2,2,2.93.43.59.89,1.16,1.34,1.73.66.83,1.33,1.65,2,2.44.49.57,1,1.12,1.51,1.66.74.78,1.49,1.53,2.27,2.26.52.49,1,1,1.57,1.46.88.79,1.8,1.53,2.73,2.26.47.37.93.75,1.41,1.11,1.42,1,2.88,2,4.39,3,.28.17.59.31.87.48,1.27.74,2.55,1.45,3.87,2.09.57.28,1.15.53,1.73.79,1.08.48,2.17.95,3.29,1.38l2,.7c1.1.37,2.22.72,3.35,1,.66.18,1.33.37,2,.53,1.22.29,2.47.53,3.73.75l.24.05q-1.23,22.19-2.2,44.39a59.83,59.83,0,0,0-83.07-26l10.58,29-21.77-20.9a59.66,59.66,0,0,0-19.34,41.34,58.5,58.5,0,0,0,1.52,16.49A59.84,59.84,0,0,0,256.36,431c0,1.5-.1,3-.14,4.51-.4,15.54-.9,34.88,6.85,52.15,5.25,11.7,13.69,21.21,22,29.73,5.43,5.54,11.06,10.91,16.83,16.1a60.09,60.09,0,0,0,21.62,18c9.48,7.3,19.3,14.17,29.45,20.51l6.34,3.94c5.7,3.53,11.54,7.16,17.26,10.93-1-.1-2-.21-3-.26a59.89,59.89,0,0,0-58.94,39L352.05,656l-41.14-9.54a59.89,59.89,0,0,0,85.82,53.92L394,703.83q-2.76,3.43-5.45,6.82c-24.34,30.83-31.11,60.09-19.06,82.4l14.66-7.91C372.37,763.42,390,735.62,401.57,721q2.64-3.33,5.36-6.7c15.55-19.32,33.17-41.22,32.74-68.08C439,605.71,399.71,581.35,368.13,561.77Z",
  transform: "translate(-86 -80.5)",
  fill: "#f2f2f2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M639.07,517.51l7.84-4.88c.75-.47,1.48-1,2.23-1.44a74.69,74.69,0,0,1-61.95-70.11,74,74,0,0,1,6.45-34,74.8,74.8,0,0,1,48-41.38l-.39,30.77L658.12,363l.2,0a74.7,74.7,0,0,1,78.09,71.13c.07,1.43,0,2.83,0,4.24,5.89-6.71,11.23-13.91,14.76-21.79,7.16-16,7.3-34,6.73-56-1.12-43.55-3-87.43-5.45-131.17a74.66,74.66,0,0,1-66.32-70.67c-.1-2.28-.07-4.53,0-6.77q0-.84.09-1.68c.14-2.17.35-4.32.67-6.43.05-.35.13-.69.19-1q.46-2.7,1.11-5.32c.16-.65.32-1.31.49-2,.53-1.9,1.1-3.79,1.77-5.63.22-.62.48-1.21.72-1.82.54-1.37,1.11-2.71,1.72-4,.32-.69.63-1.39,1-2.08.08-.17.16-.36.25-.53l0,0a74.6,74.6,0,0,1,87.68-37.87l-.5,40,16.72-33.08A74.27,74.27,0,0,1,833.7,171h.08c-.11.53-.28,1-.4,1.57-.24,1-.49,2-.76,2.93-.35,1.25-.75,2.47-1.16,3.69-.31.92-.61,1.84-1,2.75-.51,1.32-1.08,2.61-1.66,3.89-.34.75-.64,1.52-1,2.26-1,1.93-2,3.82-3.09,5.65-.38.65-.82,1.26-1.23,1.89-.8,1.24-1.61,2.46-2.48,3.65-.54.74-1.11,1.44-1.67,2.16-.82,1-1.65,2.06-2.53,3.05q-.92,1-1.89,2.07c-.91,1-1.86,1.9-2.82,2.82-.65.61-1.29,1.23-2,1.82-1.11,1-2.25,1.9-3.42,2.81-.58.46-1.15.95-1.75,1.39-1.77,1.3-3.59,2.54-5.48,3.69-.35.21-.73.39-1.09.6q-2.35,1.4-4.82,2.61c-.71.35-1.44.65-2.16,1-1.35.61-2.71,1.19-4.1,1.72-.82.31-1.64.6-2.46.88-1.38.47-2.77.89-4.18,1.28-.83.23-1.66.46-2.51.67-1.53.36-3.08.66-4.65.93l-.31.06q1.56,27.69,2.75,55.39a74.62,74.62,0,0,1,103.64-32.4L866.44,288l27.15-26.07a74.4,74.4,0,0,1,24.13,51.57A72.94,72.94,0,0,1,915.83,334a74.66,74.66,0,0,1-137.32,20.34c0,1.87.13,3.76.18,5.63.5,19.39,1.12,43.52-8.54,65.06-6.55,14.61-17.09,26.46-27.51,37.09q-10.17,10.38-21,20.09a74.94,74.94,0,0,1-27,22.43c-11.83,9.11-24.08,17.68-36.74,25.6L650,535.17c-7.11,4.4-14.39,8.93-21.54,13.63,1.26-.12,2.5-.26,3.78-.32a74.72,74.72,0,0,1,73.53,48.62l-46.66,38,51.33-11.89a74.73,74.73,0,0,1-107.08,67.26c1.16,1.44,2.31,2.88,3.47,4.31,2.29,2.85,4.58,5.69,6.81,8.51,30.36,38.45,38.81,75,23.77,102.8l-18.28-9.87c14.63-27.1-7.38-61.78-21.81-80-2.19-2.77-4.43-5.56-6.68-8.36-19.4-24.1-41.39-51.42-40.85-84.93C550.62,572.32,599.66,541.93,639.07,517.51Z",
  transform: "translate(-86 -80.5)",
  fill: "#f2f2f2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M964.66,268.71V619.29a7.21,7.21,0,0,1-7.21,7.21H242.86a7.2,7.2,0,0,1-7.2-7.21V268.71a7.2,7.2,0,0,1,7.2-7.21H957.45A7.21,7.21,0,0,1,964.66,268.71Z",
  transform: "translate(-86 -80.5)",
  fill: "#3f3d56"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M964.66,266.31V282.5h-729V266.31a4.81,4.81,0,0,1,4.81-4.81H959.85A4.81,4.81,0,0,1,964.66,266.31Z",
  transform: "translate(-86 -80.5)",
  fill: "#cbceda"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 165.66,
  cy: 191,
  r: 5,
  fill: "#00b0ff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 179.66,
  cy: 191,
  r: 5,
  fill: "#00b0ff"
});

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 193.66,
  cy: 191,
  r: 5,
  fill: "#00b0ff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M847.48,517.47v60.18l-495.2.27-.45-120.3c5.23,15.41,18.14,18.18,40.87-9,55.55-66.34,131.06-83.8,189.51-85.63,40-1.26,79.91,7,118,23.41,15.82,6.83,78.34,14.18,119.6,17.46a29.9,29.9,0,0,1,27.55,29.74Z",
  transform: "translate(-86 -80.5)",
  fill: "#00b0ff",
  opacity: 0.2
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M847.48,458.62v119.6H351.83v-26C366,548.65,419,534.92,444.41,497c30.4-45.4,71.72-57.34,103.69-58.59,21.91-.87,43.72,4.76,64.54,16,23.42,12.64,68.57,27.89,102.87-16.38,37.94-48.95,96.22-8.61,111,6.22C831.79,449.49,847.48,458.62,847.48,458.62Z",
  transform: "translate(-86 -80.5)",
  fill: "#00b0ff",
  opacity: 0.2
});

var _ref15 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "265.83 251.28 265.83 495.84 761.48 495.84",
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref16 =
/*#__PURE__*/
React.createElement("line", {
  x1: 328.28,
  y1: 495.84,
  x2: 328.28,
  y2: 346.75,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref17 =
/*#__PURE__*/
React.createElement("line", {
  x1: 388.44,
  y1: 495.84,
  x2: 388.44,
  y2: 306.87,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref18 =
/*#__PURE__*/
React.createElement("line", {
  x1: 448.6,
  y1: 495.84,
  x2: 448.6,
  y2: 287.9,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref19 =
/*#__PURE__*/
React.createElement("line", {
  x1: 508.76,
  y1: 495.84,
  x2: 508.76,
  y2: 282.02,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref20 =
/*#__PURE__*/
React.createElement("line", {
  x1: 568.92,
  y1: 495.84,
  x2: 568.92,
  y2: 288.56,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref21 =
/*#__PURE__*/
React.createElement("line", {
  x1: 629.08,
  y1: 495.84,
  x2: 629.08,
  y2: 312.75,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref22 =
/*#__PURE__*/
React.createElement("line", {
  x1: 689.24,
  y1: 495.84,
  x2: 689.24,
  y2: 325.17,
  fill: "none",
  stroke: "#00b0ff",
  strokeMiterlimit: 10
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 327.95,
  cy: 344.79,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 388.11,
  cy: 306.87,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 448.27,
  cy: 288.56,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref26 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 508.42,
  cy: 282.02,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref27 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 568.58,
  cy: 288.56,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref28 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 628.74,
  cy: 313.4,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref29 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 688.9,
  cy: 326.48,
  r: 11.12,
  fill: "#00b0ff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 514,
  cy: 718,
  rx: 514,
  ry: 21,
  fill: "#3f3d56"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.54,433.22a4.67,4.67,0,0,1-.81,2.42c4-.12,7.55-2.75,11.24-4-.66,3.88,0,8.48.5,11.78a49.16,49.16,0,0,0,2.38,9.39c2.53,10.87,7.14,21.56,11.27,32a64.31,64.31,0,0,1,4,12.87c2.81,16.85-6.91,33.15-8.75,50.12a9.51,9.51,0,0,0,0,2.82,3.59,3.59,0,0,0-.44.57c-6.79,10.42-5.91,27.86-4.69,40.2s5.13,24.24,8.82,36.09a70.67,70.67,0,0,1,2.57,10,66.43,66.43,0,0,1,.28,14c-1.22,21.71-4.28,43.61-.67,65,2.63,15.59,8.37,29.77,9,45.56a7.67,7.67,0,0,1,2.2-3l1.08,41.47a2.41,2.41,0,0,0,.78,2.1c.77.49,1.77,0,2.68-.13,2.64-.32,4.33,2.55,6.08,4.54,2.63,3,6.68,4.42,10.65,4.73a46.83,46.83,0,0,0,11.9-1.08c1.83-.33,3.77-.71,5.14-2a6.37,6.37,0,0,0,1.74-5.49c-.78-6.11-7.36-9.59-10.67-14.8-3.91-6.16-3-14.41-6.82-20.64-1.31-2.13-3.12-3.93-4.29-6.14a24.5,24.5,0,0,1-1.39-4.22,12.27,12.27,0,0,1,3.34,1.59c-.36-3.24-.73-6.49-1.09-9.74l-.16-1.4c-.49-4.39-1-8.77-1.36-13.17-1.23-14.48,2.88-28.67,0-42.92-.6-3,.36-6.13,1.25-9.08A226.28,226.28,0,0,0,208.49,631c.36-6.18.35-12.14,2.33-18,2.32,9.45,9.49,16.9,14,25.57,2.78,5.4,4.51,11.3,7.54,16.56,1.46,2.56,3.24,5,4.17,7.78,1.44,4.35.68,9.07,0,13.61-3.25,23.5-2.87,47.42-1.83,71.12a112.68,112.68,0,0,1-6.21,26.55c-1.24,3.38-2.59,7.32-.67,10.37a10.69,10.69,0,0,0,3,2.8,70.6,70.6,0,0,0,8.94,5.41,4.62,4.62,0,0,0,3.13.72,7.19,7.19,0,0,0,1.9-1c2.43-1.46,5.57-1.23,8.25-.29s5.1,2.51,7.7,3.64A26.28,26.28,0,0,0,278,797.06c2.42-.67,5-1.95,5.75-4.32s-.63-4.87-2.54-6.43-4.27-2.4-6.46-3.54a26.52,26.52,0,0,1-11.23-11.21,52.07,52.07,0,0,1-3.54-9.87q-1.74-6.12-3.47-12.24a17.25,17.25,0,0,1,1.88,1.43c1.63-20.2,3.28-40.46,7.61-60.26,2.07-9.47,4.77-19.06,3.72-28.69-.55-5.06-2.13-9.95-3.63-14.82q-7-22.79-12.26-46.06a15.5,15.5,0,0,0,3-5,36.85,36.85,0,0,0,1.83-10.6,509.92,509.92,0,0,0-.2-73c-.46-6.16-1.18-12.63-3.6-18.23l1.42,0c-1.69,0-4.45-16.78-4.78-18.65-1.13-6.48-1.92-13-3.09-19.47-.57-3.15-1.21-6.3-2-9.4-.54-2.06-2.7-14.85-4.42-16.28a2.14,2.14,0,0,0-.62-.36,12.22,12.22,0,0,0-5.31-6.9c-2.77-1.56-6.07-1.61-9.3-1.36q-1.37-2-2.74-3.95a23.11,23.11,0,0,1-3.79-7.19,17.58,17.58,0,0,1-.46-3.32c0-.75-.05-1.5-.08-2.25,0-.38,0-.75,0-1.13a18.53,18.53,0,0,0-.24-2.23v0c-.1-.61-.25-1.2-.41-1.8-.07-.25-.16-.51-.24-.76-.46-1.51-1-3-1.4-4.52-1.23-4.91-.61-10.06-.42-15.12s-.14-10.42-3-14.64c-2.09-3.1-5.44-5.45-6.56-9-.53-1.69-.5-3.55-1.28-5.15a8.54,8.54,0,0,0-4.56-3.82c-2.26-1-6.8-2.32-9.23-1.15a3.59,3.59,0,0,0-1.18.94c-2.57.13-5.16.48-7.42-.65-1.74-.87-3-2.52-4.69-3.47-4-2.24-9.1,0-12.66,2.92a36.5,36.5,0,0,0-11.87,17.88c-1.58,5.41-2.22,11.73-6.75,15.14-1.88,1.41-4.3,2.19-5.67,4.08a10.39,10.39,0,0,0-1.5,5.09c-.47,4.1-.86,8.32.23,12.3.82,3,2.43,5.68,3.43,8.6A22.65,22.65,0,0,1,138,432.27,7.47,7.47,0,0,0,143.54,433.22ZM239.7,554.55a10.76,10.76,0,0,0,5.39-7.17c.11.39.2.78.3,1.17a27.77,27.77,0,0,1-.75,15.78A56.76,56.76,0,0,0,239.7,554.55Zm2-22.14a41.17,41.17,0,0,1-4.2-7.63c-1.54-4.32-1.19-9-.82-13.62a64.26,64.26,0,0,1,1.44-10.36A220.84,220.84,0,0,0,241.73,532.41Z",
  transform: "translate(-86 -80.5)",
  fill: "url(#abc71e73-d4d0-48d8-8443-969b5fcd59ae)"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203,349.56a8.43,8.43,0,0,1,4.48,3.79c.76,1.59.74,3.44,1.26,5.12,1.1,3.54,4.4,5.88,6.44,9,2.78,4.19,3.11,9.53,2.92,14.55s-.79,10.15.42,15c.59,2.37,1.61,4.64,2,7.05.5,2.94.08,6,.81,8.89a22.91,22.91,0,0,0,3.73,7.14l6.51,9.52A73.79,73.79,0,0,1,223,427a15.33,15.33,0,0,0,4.64,7l-4.71-5.7a13.3,13.3,0,0,0-3.5-3.32c-1.73-1-3.77-1.14-5.71-1.53-3.74-.76-7.47-2.67-9.3-6-2.43-4.48-.88-10.1-2.23-15-1-3.58-3.46-6.53-5.16-9.84-3.84-7.47-3.61-16.29-4.81-24.62-.51-3.53-1.3-7-1.32-10.62,0-2.63.26-7.65,3-9C196.31,347.25,200.77,348.61,203,349.56Z",
  transform: "translate(-86 -80.5)",
  fill: "#3f3d56"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M255.42,744.21l5,17.77a51.76,51.76,0,0,0,3.48,9.81,26.11,26.11,0,0,0,11,11.15c2.15,1.13,4.48,2,6.35,3.52s3.21,4.07,2.49,6.39-3.27,3.63-5.65,4.3a25.62,25.62,0,0,1-17-1.23c-2.55-1.13-4.93-2.69-7.56-3.62s-5.73-1.17-8.11.29a7.11,7.11,0,0,1-1.87,1,4.46,4.46,0,0,1-3.08-.71,68.68,68.68,0,0,1-8.79-5.38,10.39,10.39,0,0,1-2.9-2.78c-1.9-3-.56-7,.65-10.31a113.11,113.11,0,0,0,6.23-27.49,2.89,2.89,0,0,1,.91-2.23,2.82,2.82,0,0,1,1.44-.32l21.36-1",
  transform: "translate(-86 -80.5)",
  fill: "#575a89"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.12,762c1.15,2.19,2.94,4,4.22,6.11,3.75,6.19,2.86,14.39,6.71,20.51,3.25,5.18,9.72,8.65,10.49,14.72a6.38,6.38,0,0,1-1.71,5.45c-1.35,1.25-3.26,1.62-5.06,1.94a45.22,45.22,0,0,1-11.69,1.08c-3.91-.31-7.89-1.75-10.47-4.71-1.73-2-3.38-4.83-6-4.5-.9.11-1.88.61-2.64.12a2.42,2.42,0,0,1-.76-2.08l-1.18-45.47c3.78-.41,10.33-1.91,14-.61C199.19,755.67,198.68,759.23,200.12,762Z",
  transform: "translate(-86 -80.5)",
  fill: "#575a89"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M237.44,551.81c9.22,11.47,11.95,26.66,14.91,41.08q5.72,27.9,14.06,55.18c1.48,4.84,3,9.7,3.57,14.73,1,9.58-1.62,19.11-3.66,28.52-4.25,19.69-5.87,39.83-7.47,59.91A19.14,19.14,0,0,0,235.63,750c-1.08-24.21-1.57-48.67,1.71-72.69.62-4.51,1.37-9.2,0-13.52-.92-2.78-2.66-5.19-4.11-7.73-3-5.24-4.68-11.1-7.41-16.47-4.39-8.62-11.44-16-13.72-25.42-1.95,5.84-1.94,11.76-2.29,17.9a227.33,227.33,0,0,1-9,51.42c-.88,2.94-1.82,6-1.23,9,2.8,14.18-1.24,28.28,0,42.68.36,4.37.85,8.73,1.33,13.09l.16,1.4,1.08,9.68c-4-2.73-8.23-2.34-13.06-2.09a14.06,14.06,0,0,0-4.78.84A7.79,7.79,0,0,0,180,762.4c-.58-15.7-6.23-29.8-8.81-45.29-3.55-21.32-.55-43.1.66-64.68a67,67,0,0,0-.28-13.95,71.82,71.82,0,0,0-2.53-10c-3.62-11.78-7.47-23.61-8.67-35.88s-2.06-29.6,4.61-40c2.06-3.2,7.13-1.76,10.33-3.84a26.05,26.05,0,0,1,8.2-3.36C201,541.34,219.56,550.27,237.44,551.81Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M205.87,409.47c.39,4.37,1.31,9.52,5.29,11.36,2.26,1,4.88.65,7.32,1.05,4.62.75,8.42,4.3,10.56,8.46s2.88,8.89,3.38,13.54c.62,5.83.82,12.15-2.38,17.06-2.58,4-7,6.39-11.64,7.62a32.45,32.45,0,0,1-27.11-5,60.77,60.77,0,0,1-10-9.86c-6.64-7.73-13.33-16.2-14.69-26.3-.16-1.15-.15-2.54.79-3.22a3.47,3.47,0,0,1,2.14-.42l6.37.11c1.61,0,3.43,0,4.53-1.21s1-2.75,1-4.23L181,399.94a2.66,2.66,0,0,1,.43-1.87,2.43,2.43,0,0,1,1.46-.63c3.51-.59,7.18,0,10.61-.95,3.27-.9,8.4-4.65,10.8-.8C206.3,399,205.54,405.74,205.87,409.47Z",
  transform: "translate(-86 -80.5)",
  fill: "#ffc1c7"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M205.87,409.47c.39,4.37,1.31,9.52,5.29,11.36,2.26,1,4.88.65,7.32,1.05,4.62.75,8.42,4.3,10.56,8.46s2.88,8.89,3.38,13.54c.62,5.83.82,12.15-2.38,17.06-2.58,4-7,6.39-11.64,7.62a32.45,32.45,0,0,1-27.11-5,60.77,60.77,0,0,1-10-9.86c-6.64-7.73-13.33-16.2-14.69-26.3-.16-1.15-.15-2.54.79-3.22a3.47,3.47,0,0,1,2.14-.42l6.37.11c1.61,0,3.43,0,4.53-1.21s1-2.75,1-4.23L181,399.94a2.66,2.66,0,0,1,.43-1.87,2.43,2.43,0,0,1,1.46-.63c3.51-.59,7.18,0,10.61-.95,3.27-.9,8.4-4.65,10.8-.8C206.3,399,205.54,405.74,205.87,409.47Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref38 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 103.84,
  cy: 303.43,
  r: 24.33,
  fill: "#ffc1c7"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M216,451.61c3.93.07,8.37-1,10.27-4.48,1.3-2.36,1.09-5.23.84-7.91l-1.41-15c3.82-.4,7.93-.74,11.26,1.15,4.43,2.51,6,8.07,6.52,13.13.93,9.5-.58,19.09-.06,28.62.44,8,2.29,16.26-.07,23.93-1,3.2-2.66,6.15-3.74,9.32-1.35,4-1.7,8.3-2,12.53-.37,4.54-.72,9.24.8,13.54,1.27,3.6,3.75,6.63,5.52,10,2.9,5.58,3.52,13.1-.84,17.63-4,4.14-10.58,4.31-16.17,3s-11-3.81-16.7-4.05c-10.12-.43-19.14,6.14-29,8.27a9,9,0,0,1-4.05.14,10,10,0,0,1-3.26-1.78l-5.42-3.9a7.47,7.47,0,0,1-2.62-2.65,7.18,7.18,0,0,1-.34-3.8c1.82-16.88,11.37-33.08,8.61-49.83a64.35,64.35,0,0,0-3.92-12.8c-6.87-17.58-15.11-35.84-12.44-54.53.58-4.14,1.8-8.37,4.65-11.43s7.67-4.58,11.36-2.62,5,6.32,6.63,10.11a46.6,46.6,0,0,0,14.48,18.68c2.68,2.06,5.93,4.69,9.44,4.78C208,451.79,212,451.53,216,451.61Z",
  transform: "translate(-86 -80.5)",
  fill: "#ff6584"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M251.24,489.41c5.9,6.55,7.06,16,7.71,24.78a509.62,509.62,0,0,1,.19,72.58,37.16,37.16,0,0,1-1.79,10.55c-1.26,3.35-3.62,6.45-6.94,7.79-2.13.86-5.1.63-6.06-1.46-.88-1.91.43-4,1.42-5.9a21.41,21.41,0,0,0,2.16-13.94c-1.21.88-1.64,2.47-2,3.93L244,595.86c-2.61-.38-3.59-3.57-4-6.17-.76-4.72-1.49-9.75.4-14.14,1-2.34,2.7-4.33,3.71-6.67,2.55-5.88,3.55-12.6,1.91-18.8a220.29,220.29,0,0,1-7.16-64.2A27.36,27.36,0,0,0,251.24,489.41Z",
  transform: "translate(-86 -80.5)",
  fill: "#ffc1c7"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.81,496a89.81,89.81,0,0,0-21.52,2.84c-.93-4.58-.48-9.32,0-14l3.1-32c.23-2.37-.21-24.14,4.38-20.29,1.69,1.42,3.82,14.14,4.35,16.19.8,3.08,1.43,6.2,2,9.34,1.15,6.43,1.93,12.92,3,19.36C252.43,479.35,255.15,496,256.81,496Z",
  transform: "translate(-86 -80.5)",
  fill: "#ff6584"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.12,353a4.31,4.31,0,0,0-.5-2.19,3.67,3.67,0,0,0-2.61-1.37c-3.52-.55-7.37.87-10.54-.74-1.72-.87-2.94-2.5-4.61-3.45-4-2.23-9,0-12.45,2.91a36.27,36.27,0,0,0-11.66,17.76c-1.56,5.38-2.19,11.67-6.64,15.06-1.85,1.4-4.23,2.18-5.58,4.06a10.35,10.35,0,0,0-1.47,5c-.46,4.08-.85,8.28.22,12.24.81,3,2.39,5.64,3.38,8.54a22.69,22.69,0,0,1-6.19,23.61,7.3,7.3,0,0,0,5.45.94,4.79,4.79,0,0,1-.79,2.41c5.69-.18,10.64-5.73,16.21-4.52,4.26.92,6.63,5.31,9.8,8.3,4.09,3.84,10.44,5.45,15.57,3.17s8.25-8.76,6.07-13.94c-2.48-5.89-10.13-8.22-12.78-14-2.05-4.5-.53-9.77-1-14.7-.37-4.23-2.2-8.18-3.34-12.28s-1.51-8.78.81-12.34c2.46-3.79,7.17-5.26,11.46-6.66C197.62,367.66,199.48,362.78,199.12,353Z",
  transform: "translate(-86 -80.5)",
  fill: "#3f3d56"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.14,440.47c.69-3.4,1.38-7,.15-10.26-2.27-6-9.72-7.93-14.87-11.82a20.16,20.16,0,0,1-6.62-8.82c-.93-2.46-1.06-5.84,1.24-7.1a5.61,5.61,0,0,1,2.87-.51c8,.19,15.39,4.55,21.54,9.72,3.58,3,7,6.44,8.76,10.76a35.24,35.24,0,0,1,2,9.67L209.5,443A171.8,171.8,0,0,1,211,461.85a84.49,84.49,0,0,1-.68,10.79c-.32,2.54-.8,5.17-2.29,7.25-2.77,3.88-8.12,4.75-12.89,4.88a22.57,22.57,0,0,1-5.39-.34c-7.93-1.72-13.95-12.83-7.94-19.69,2.55-2.91,6.37-3,7.83-7C191.52,452.43,192,446,193.14,440.47Z",
  transform: "translate(-86 -80.5)",
  fill: "#ffc1c7"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M186.69,442.38,193,452.61a4.69,4.69,0,0,1,.77,1.76c.17,1.33-.82,2.51-1.61,3.6-5.4,7.36-4,17.5-2.4,26.48a48,48,0,0,1-33.05-38.92c-.79-5.35-2.06-14.16,2.69-17.64C170.79,419.49,181.33,433.61,186.69,442.38Z",
  transform: "translate(-86 -80.5)",
  fill: "#ff6584"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M218.48,421.88c-2.44-.4-5.06,0-7.32-1.05-4-1.84-4.9-7-5.29-11.36,0-.41-.05-.85-.07-1.32a36,36,0,0,1,4.63-4,22.76,22.76,0,0,1,4.73-2.09l4.42-1.55a25,25,0,0,1,1,3.59c.5,2.94.08,6,.81,8.89a22.91,22.91,0,0,0,3.73,7.14l6.51,9.52q-1.77-.42-3.51-.93C225.85,425.27,222.48,422.53,218.48,421.88Z",
  transform: "translate(-86 -80.5)",
  fill: "#3f3d56"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1101,464c-1.16-5.63-3.33-11-4.64-16.58a69.07,69.07,0,0,0-2.17-8.61,20.53,20.53,0,0,0-1.73-3.52l.62-.58c-2.06-3.48-2.14-7.84-3.11-11.8-.84-3.41-2.51-6.53-3.52-9.89-1.4-4.66-1.59-9.92-4.48-13.77-1.14-1.52-2.63-2.71-3.9-4.12-1.46-1.61-2.61-3.5-4.09-5.08-4.3-4.58-10.78-6-16.91-6.66s-12.47-.65-18.12-3.2c-2.37-1.07-4.87-2.6-7.35-2.42a35.37,35.37,0,0,1-3.83-4.35,59.22,59.22,0,0,1-5.12-7.25,26.69,26.69,0,0,0,2.74-6.44l.41-.29c1.61-1.22,3-2.81,4.58-4,1.39-1,3.18-2.05,3.33-3.83s-1.46-3.14-2.46-4.61c-3.61-5.27.38-13.52-3.32-18.73-1.85-2.61-5.08-3.6-8-4.87-4-1.76-7.57-4.29-11.54-6s-8.56-2.64-12.56-1c-7.48,3.1-10.17,13.75-17.77,16.53a3.73,3.73,0,0,0-2.11,1.25c-.93,1.52-2.16,10.47-1.94,12.32.29,2.45.88,3.66,2.57,4.52,0,.52,0,1.05,0,1.58,0,12.73,8.82,23.3,20.45,25.48a17.7,17.7,0,0,1,2.82,3.93,15,15,0,0,1,1,4.75,2.88,2.88,0,0,0-1.34-.28,3.86,3.86,0,0,0-3.17,2.77,13.66,13.66,0,0,0-.49,4.52,3.07,3.07,0,0,1-.88,2.59,2.69,2.69,0,0,1-1.21.38,28.35,28.35,0,0,1-4.68.48c-2.6,0-5.39-.65-7.68.62s-3.33,4-4.43,6.47a40.06,40.06,0,0,1-6.23,9.75c-2.8,3.24-6.28,6.31-7.07,10.6a1.51,1.51,0,0,0,0,.3c-2.19,1-4.43,3.4-6,4.61A114.66,114.66,0,0,0,949,437c-2.81,2.71-6.6,6.07-8.34,9.69a13.63,13.63,0,0,1-3.48,4c-2.85,1.85-6.53.87-9.74-.17-8.9-2.87-17.85-5.77-26.15-10.16a2.05,2.05,0,0,0-1.4-.35,1.53,1.53,0,0,0-.7.46,3.3,3.3,0,0,0-.22-.3c-2.24-2.42-5.76-2.58-7-6.28a21.76,21.76,0,0,1-.73-3.59,39.35,39.35,0,0,0-3.77-10.14,3.78,3.78,0,0,0-1.24-1.66,2.29,2.29,0,0,0-3,.95,5.58,5.58,0,0,0-.64,3.43c.08,1.3.27,2.81-.63,3.74a3.06,3.06,0,0,1-1.28.72c-2.89.94-6.07.1-8.77-1.31s-5.13-3.37-7.8-4.86a40.37,40.37,0,0,0-4.36-2.06c-1.54-.64-3.68-1.06-4.54.41-.69,1.18,0,2.69.8,3.81a30.39,30.39,0,0,0,4.65,5.28c5.2,4.65,11.75,7.24,17.85,10.48a91.07,91.07,0,0,1,15,10,7.74,7.74,0,0,0-.33,1.79,8.5,8.5,0,0,0,2.78,6.27,23.57,23.57,0,0,0,5.77,3.78q15.88,8.25,32,16.07a5.52,5.52,0,0,0,2.23.72c2.18.05,3.57-2.31,5.32-3.67s4-1.74,6.11-2.45c3.75-1.29,7-3.74,10.21-6.16l10.23-7.74c5.15-3.89,10.43-8,14.75-12.8a9.22,9.22,0,0,0,2.28,3c-.84,1.87.91,3.81,1.33,5.83a23.77,23.77,0,0,1,.11,4,36.64,36.64,0,0,0,1,5.77,55.07,55.07,0,0,1,.68,9.35c0,3.49.11,7,.16,10.48.07,4.52.14,9.09-.81,13.5-1.29,6-4.45,11.7-4.2,17.86a6.88,6.88,0,0,1-.33,3.42c-2.61,5-4.67,10.51-7.48,15.43a16.9,16.9,0,0,0-2,3.86,6.55,6.55,0,0,0,.4,4.27,14.52,14.52,0,0,0-1.83,6.51c-.19,5.65,2.08,11,3.17,16.57,1,5.11,1,10.35,1.15,15.56.77,24.38,5.54,48.48,6.53,72.85a236.68,236.68,0,0,1-1,33.68c-.73,7.22-1.81,14.42-2.21,21.68-1.15,20.6,3.15,41,7.42,61.2a8,8,0,0,1,5.08-2.75c-.52,2-1.21,4.6-1.93,6.52a7.57,7.57,0,0,0-2.94,1.06c-2.49,1.59-3.34,4.85-4.79,7.49-3.17,5.75-9.4,8.7-14.51,12.65-2.45,1.89-4.92,4.78-4.15,7.85,8.85,2.57,18.49,4.85,27,1.31,3.46-1.43,6.7-3.8,10.41-3.92,2.82-.09,5.7,1.14,8.4.3a3,3,0,0,0,1.66-1.15,4,4,0,0,0,.44-2,132.83,132.83,0,0,0-.06-14.11c-.23-4,.18-7-3.07-7.56a31.65,31.65,0,0,1-1.79-6.23c0-.39-.09-.8-.14-1.21a14.88,14.88,0,0,0,2.67-.22,13,13,0,0,0,1.61-.38c-.17-.69-.32-1.39-.46-2.08-.28-1.39-.5-2.78-.68-4.17s-.31-2.8-.41-4.2c0-.71-.08-1.41-.11-2.12-.06-1.41-.08-2.82-.07-4.24s0-2.83.1-4.25.14-2.84.24-4.26c.24-3.55.59-7.1.94-10.62q1.53-15.51,3.08-31c.3-3.1.61-6.21.65-9.32a41.47,41.47,0,0,0-.26-5.57c-.53-4.48-1.94-9-2-13.42a18.14,18.14,0,0,1,.08-2.21,15.31,15.31,0,0,1,.37-2.2c.09-.4.21-.8.33-1.19.25-.79.53-1.56.78-2.35.13-.39.25-.79.36-1.19a27,27,0,0,0,.73-5.15c0-.58.07-1.16.1-1.74l1.23-24.38c.2-3.91.53-8.13,2.06-11.62a12.41,12.41,0,0,1,2.83-4.09c-.31-.83,0-2.23.86-2.45a206.49,206.49,0,0,1-.37,37.38c-.44,3.9-1.09,7.77-1.27,11.69-.38,8.64,1.53,17.19,2.2,25.81s0,17.5,0,26.25c-.07,15.05,1.59,30.05,3.24,45l1,.66c0,1.32.15,2.76.13,4a3.63,3.63,0,0,0,.13,1.28l-.42,0a6,6,0,0,0-4.7,3,19.11,19.11,0,0,0-2.13,5.5,11.45,11.45,0,0,0-.6,4.44c.38,2.85,2.8,5,3.44,7.8,1.17,5.07-3.8,10.54-1.54,15.2,1.44,3,5.07,3.83,8.24,4.35,4.84.79,10.35,1.42,14.16-1.79a9.43,9.43,0,0,0,3.25-7.24c0-3.66-2.17-6.92-3.12-10.44-1.34-4.94.66-11.58-1.45-16.14A3.87,3.87,0,0,0,1041,769l.72,0c-.17-1.67-.34-3.35-.52-5l1.68-.86c1.73-.87,3.73-1.53,5.53-.85-.67-8.59-.86-18.08,1.12-26.44,1.54-6.6,4.3-12.86,5.58-19.52,1-5.49,1.07-11.13,1.09-16.72,0-10.38,0-20.83-1.74-31-.7-4.08-1.7-8.26-.94-12.34.5-2.69,1.72-5.17,2.44-7.81,1.68-6.17.45-12.8,1.45-19.13,2.38-15.12,3.64-30.9,5.45-46.09a188.38,188.38,0,0,0,.92-25.92l0-.1,3.59-7c2.57-5,5.18-10.08,6.74-15.45a10.25,10.25,0,0,1,1.29,2.45L1091.18,511a20.71,20.71,0,0,0,2.41-5c.36-1.27.48-2.6.75-3.89.71-3.35,2.41-6.37,3.77-9.49A48.17,48.17,0,0,0,1101,464Zm-23.61,13.16a105,105,0,0,1-3,12.75c-2.08,7.18-4.49,14.24-6.9,21.31l-2.07,6a25.27,25.27,0,0,1-3.18,6.81,14.06,14.06,0,0,0-.85,1.63c-2.14-8,.18-17-.31-25.53-.37-6.45-2.37-13-.87-19.25,1-4.21,3.52-7.83,5.29-11.77,1.65-3.66,2.68-7.65,4.54-11.18,0,.07,0,.13.07.19a91.84,91.84,0,0,0,5.93,12.61,10.25,10.25,0,0,1,1.45,3A8.74,8.74,0,0,1,1077.42,477.18Z",
  transform: "translate(-86 -80.5)",
  fill: "url(#bdd0ebe0-6a5f-4260-a4c1-52643e5fb488)"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M891.71,433.86a20.75,20.75,0,0,1-.76-3.6c-.65-3.59-2.31-6.9-3.94-10.17a3.71,3.71,0,0,0-1.29-1.67,2.47,2.47,0,0,0-3.1.95,5.51,5.51,0,0,0-.67,3.44c.09,1.32.29,2.83-.64,3.76a3.27,3.27,0,0,1-1.35.72c-3,.95-6.33.1-9.16-1.31s-5.35-3.39-8.14-4.88a43.35,43.35,0,0,0-4.55-2.06c-1.61-.65-3.84-1.07-4.74.41-.72,1.18,0,2.69.83,3.82a30.12,30.12,0,0,0,4.86,5.29c5.42,4.67,12.27,7.27,18.64,10.52a95.92,95.92,0,0,1,19.8,13.46,4.3,4.3,0,0,0,1-2.45c.48-2.55,2.59-7.71.46-9.92C896.63,437.74,893,437.58,891.71,433.86Z",
  transform: "translate(-86 -80.5)",
  fill: "#a0616a"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M992,777.25a25.76,25.76,0,0,0,18.83,5.28c1.4-.17,3-.67,3.46-2a3.92,3.92,0,0,0-.26-2.4,42.67,42.67,0,0,1-2.43-7.8c-.35-2.43-.26-5.32-2.24-6.78-2.86-2.11-10.34-2-12.2,1.27C996.72,765.52,993.92,778.86,992,777.25Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1032.29,765.45a1.91,1.91,0,0,0,1.63,2.38,53.55,53.55,0,0,0,14.16,2.37l-1-9.62a1.49,1.49,0,0,0-1.59-1.62c-2.76-.46-8.56-2.33-11.21-1.37C1031.3,758.67,1032.35,762.58,1032.29,765.45Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1004.36,381.74a17,17,0,0,1,1.13,6.33c.25,7.75-1.08,16.12-6.48,21.68,6.06-1.81,12.87-.72,18.59-3.42,2.65-1.25,4.88-3.24,7.36-4.79,4.42-2.76,9.57-4.1,14.17-6.56s8.86-6.61,9.12-11.81c-2-2.1-5.21-2.4-7.83-3.67-2.82-1.38-4.91-3.9-6.9-6.33a50.54,50.54,0,0,1-6.14-8.71,16.91,16.91,0,0,1-2-10.3c-5.11.92-8.82,5.38-13.65,7.29-1.88.74-3.91,1.08-5.74,1.93-2.61,1.2-7.9,5.28-8,8.48C998,375.35,1003,378.66,1004.36,381.74Z",
  transform: "translate(-86 -80.5)",
  fill: "#a0616a"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1004.36,381.74a17,17,0,0,1,1.13,6.33c.25,7.75-1.08,16.12-6.48,21.68,6.06-1.81,12.87-.72,18.59-3.42,2.65-1.25,4.88-3.24,7.36-4.79,4.42-2.76,9.57-4.1,14.17-6.56s8.86-6.61,9.12-11.81c-2-2.1-5.21-2.4-7.83-3.67-2.82-1.38-4.91-3.9-6.9-6.33a50.54,50.54,0,0,1-6.14-8.71,16.91,16.91,0,0,1-2-10.3c-5.11.92-8.82,5.38-13.65,7.29-1.88.74-3.91,1.08-5.74,1.93-2.61,1.2-7.9,5.28-8,8.48C998,375.35,1003,378.66,1004.36,381.74Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1070.15,583.7c-1.89,15.24-3.2,31.08-5.69,46.25-1,6.35.24,13-1.51,19.2-.75,2.65-2,5.14-2.55,7.83-.79,4.1.25,8.29,1,12.39,1.84,10.25,1.84,20.74,1.81,31.16,0,5.61,0,11.27-1.13,16.78-1.34,6.69-4.22,13-5.83,19.58-2.07,8.4-1.87,17.92-1.17,26.54-1.88-.68-4,0-5.78.85s-3.58,2-5.57,2.13c-2.69.25-5.22-1.17-7.54-2.55-1.78-1.05-3.33-2-5.1-3.08-1.73-15-3.46-30.06-3.39-45.17,0-8.78.69-17.58,0-26.34s-2.7-17.24-2.29-25.9c.19-3.94.86-7.82,1.31-11.73,1.48-12.66,1.28-24.8.39-37.51-.87.22-1.22,1.62-.9,2.45a12.55,12.55,0,0,0-3,4.11c-1.6,3.5-1.94,7.74-2.15,11.66l-1.29,24.47a32,32,0,0,1-.86,6.91c-.45,1.61-1.13,3.13-1.54,4.75-1.47,5.86.89,11.9,1.64,17.89.61,5,.09,10-.42,14.94l-3.21,31.12c-1.17,11.32-2.31,22.88,0,34,.15.69.3,1.39.48,2.09a14.5,14.5,0,0,1-1.68.38,21.55,21.55,0,0,1-6,0c-1.86-.19-3.74-.51-5.58-.73-4.42-.5-8.83-.69-11.76,2.65-4.46-20.22-8.94-40.75-7.75-61.42.42-7.28,1.54-14.51,2.31-21.76a226.94,226.94,0,0,0,1.08-33.79c-1-24.46-6-48.65-6.83-73.12-.17-5.22-.15-10.49-1.19-15.61-1.14-5.55-3.51-11-3.32-16.63s4.3-11.88,10-11.57c15.73.87,30.1-7.81,45.79-9.29,7.12-.68,14.36-1.69,21.41-.42s14.07,5.26,16.84,11.86c1.5,3.59,1.62,7.57,1.73,11.45C1071.23,561.6,1071.52,572.71,1070.15,583.7Z",
  transform: "translate(-86 -80.5)",
  fill: "#575a89"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M991.13,775.67c-2.6,1.6-3.49,4.87-5,7.52-3.31,5.77-9.81,8.73-15.15,12.69-2.56,1.91-5.14,4.8-4.33,7.89,9.24,2.57,19.3,4.86,28.21,1.31,3.61-1.44,7-3.82,10.87-3.94,2.95-.09,6,1.15,8.77.3a3,3,0,0,0,1.74-1.15,4,4,0,0,0,.46-2,126.39,126.39,0,0,0-.07-14.17c-.28-4.61.34-7.87-4.92-7.67C1005.67,776.71,996.37,772.44,991.13,775.67Z",
  transform: "translate(-86 -80.5)",
  fill: "#cbceda"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1035.41,767.47a11.08,11.08,0,0,0-3.42-.77,6.35,6.35,0,0,0-4.91,3,18.48,18.48,0,0,0-2.22,5.52,11,11,0,0,0-.62,4.45c.39,2.86,2.92,5,3.59,7.82,1.21,5.09-4,10.58-1.62,15.26,1.51,3,5.3,3.84,8.61,4.36,5.06.8,10.81,1.43,14.79-1.8a9.33,9.33,0,0,0,3.4-7.25c-.06-3.68-2.27-6.95-3.27-10.49-1.39-5,.7-11.62-1.51-16.19C1046.34,767.47,1039.44,768.76,1035.41,767.47Z",
  transform: "translate(-86 -80.5)",
  fill: "#cbceda"
});

var _ref55 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 920.05,
  cy: 271.73,
  r: 25.99,
  fill: "#a0616a"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1019.83,394.82a13.86,13.86,0,0,0-8.87-.67l-2.37-4.13c-1-1.82-2.49-3.88-4.58-3.8a4,4,0,0,0-3.31,2.79,13.22,13.22,0,0,0-.52,4.53,3,3,0,0,1-.91,2.61,3.19,3.19,0,0,1-1.26.38,32.14,32.14,0,0,1-4.89.48c-2.72,0-5.63-.66-8,.62s-3.47,4-4.62,6.5a40.25,40.25,0,0,1-6.5,9.78c-2.93,3.25-6.56,6.33-7.39,10.63-.35,1.83,1.31,3.19,2.63,4.51,5.25,5.21,12.57,8.41,16.46,14.71.91,1.47,1.65,3.13,3.05,4.14-.87,1.89,1,3.83,1.39,5.86a22.86,22.86,0,0,1,.11,4,35.69,35.69,0,0,0,1,5.79,53.45,53.45,0,0,1,.71,9.38l.17,10.52c.07,4.54.14,9.12-.85,13.55-1.35,6-4.65,11.75-4.39,17.92a6.63,6.63,0,0,1-.34,3.44c-2.73,5-4.88,10.54-7.81,15.48a16.4,16.4,0,0,0-2,3.88c-.78,2.85.82,5.94,3.18,7.72s5.34,2.51,8.24,3.06c26.94,5.16,54.91-1.05,80.37-11.25a5.34,5.34,0,0,0,1.83-1c1.86-1.81.4-4.86-.66-7.22-4-8.79-.81-19-1.38-28.6-.38-6.47-2.48-13-.9-19.32,1-4.22,3.67-7.86,5.52-11.8,2-4.27,3.12-9,5.74-12.9a39.13,39.13,0,0,1,6.83-7.2l16.25-14.48c-2.15-3.49-2.24-7.87-3.25-11.84-.88-3.42-2.63-6.56-3.68-9.92-1.46-4.68-1.66-10-4.68-13.83-1.19-1.53-2.74-2.72-4.07-4.13-1.52-1.62-2.72-3.51-4.27-5.1-4.49-4.6-11.26-6.06-17.65-6.68s-13-.65-18.92-3.21c-2.9-1.25-6-3.14-9-2.2-2.38.74-3.91,3.07-4.88,5.38s-1.65,4.8-3.24,6.73C1026.16,392.23,1022.69,393.75,1019.83,394.82Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M942.5,446.7a13.94,13.94,0,0,1-3.64,4c-3,1.85-6.81.87-10.16-.17-9.29-2.89-18.64-5.79-27.31-10.2a2.16,2.16,0,0,0-1.46-.35,2,2,0,0,0-1,.72,42.51,42.51,0,0,0-3.75,4.81A11,11,0,0,0,893,450.9a8.4,8.4,0,0,0,2.89,6.29,24.93,24.93,0,0,0,6,3.79q16.59,8.28,33.4,16.13a5.91,5.91,0,0,0,2.33.72c2.28.05,3.73-2.32,5.55-3.68s4.21-1.74,6.38-2.46c3.92-1.29,7.33-3.75,10.67-6.18l10.68-7.76c9.36-6.8,19.19-14.21,23.28-25l-13-4.28c-3.9-1.29-8-3.25-12.05-4-3-.58-6.61,3.38-8.86,5.07a114.92,114.92,0,0,0-9.11,7.51C948.28,439.69,944.32,443.07,942.5,446.7Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1065.55,532.07c-3.67,1.46-7.83-.74-11.72-.09a16.15,16.15,0,0,0-5.14,2.13l-11.36,6.35c-.7.38-1.46,1.31-.85,1.81a1.22,1.22,0,0,0,.59.2c3.79.49,7.33-1.82,11.1-2.46a25.72,25.72,0,0,1,5-.19,2,2,0,0,1,.81.12,1.68,1.68,0,0,1,.84,1.59c0,.64-.19,1.26-.21,1.9a7,7,0,0,0,1.65,4,122.42,122.42,0,0,0,12,14.66,25.55,25.55,0,0,0,2.86-4.52l3.74-7c3.88-7.22,7.85-14.71,8.47-22.88-2.8-.89-8-3.84-10.89-2.29S1068.88,531,1065.55,532.07Z",
  transform: "translate(-86 -80.5)",
  fill: "#a0616a"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.76,348.08c7.32.78,14,4.24,20.55,7.64-1.12,1.76.3,4.29,2.29,4.89s4.17-.25,5.86-1.48,3.08-2.82,4.78-4c1.46-1,3.32-2.06,3.48-3.84s-1.52-3.15-2.57-4.63c-3.77-5.29.4-13.57-3.46-18.8-1.94-2.62-5.31-3.61-8.3-4.89-4.14-1.76-7.91-4.3-12.06-6.05s-8.93-2.66-13.11-1c-7.82,3.11-10.62,13.8-18.56,16.59a4,4,0,0,0-2.21,1.26c-1,1.52-2.25,10.51-2,12.36.38,3.09,1.23,4.23,4.27,5.15C988.22,353.22,995.8,347.33,1002.76,348.08Z",
  transform: "translate(-86 -80.5)",
  fill: "#3f3d56"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1097.53,431a20.77,20.77,0,0,1,5.35,7.74,65.7,65.7,0,0,1,2.26,8.64c1.37,5.62,3.63,11,4.84,16.64a46.56,46.56,0,0,1-3,28.68c-1.42,3.14-3.2,6.16-3.94,9.53-.28,1.29-.41,2.63-.78,3.9a20.84,20.84,0,0,1-2.52,5l-16.4,26.39a11.73,11.73,0,0,0-7-6.64,18.72,18.72,0,0,0-9.8-.59c1.22-1.92,1.76-4.07,3-6a33.54,33.54,0,0,0,1.87-3.18,33.05,33.05,0,0,0,1.46-3.65l2.15-6.07c2.52-7.09,5-14.18,7.21-21.38a100.91,100.91,0,0,0,3.16-12.8,8.79,8.79,0,0,0,.08-3.35,10.43,10.43,0,0,0-1.52-3.06,91.3,91.3,0,0,1-6.19-12.64c-1.3-3.05-2.61-6.48-1.44-9.58a12.15,12.15,0,0,1,3.22-4.26A95.14,95.14,0,0,1,1097.53,431Z",
  transform: "translate(-86 -80.5)",
  fill: "#3c354c"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014.19,768.88l1.2-2.47c-2.3-11.1-1.16-22.66,0-34l3.21-31.12c.51-5,1-10,.42-14.94-.75-6-3.11-12-1.64-17.89.41-1.62,1.09-3.14,1.54-4.75a32,32,0,0,0,.86-6.91l1.29-24.47c.21-3.92.55-8.16,2.15-11.66V620l-4.12-35.46-10.88,184.34Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M920.6,784.17c3-5.51-.4-12.27-4.29-17.18s-8.61-10-8.51-16.29c.15-9,9.7-14.31,17.33-19.09a84,84,0,0,0,15.56-12.51,22.8,22.8,0,0,0,4.78-6.4c1.58-3.52,1.54-7.52,1.44-11.37q-.51-19.26-1.91-38.49",
  transform: "translate(-86 -80.5)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M959.51,662.14a14,14,0,0,0-7-11.5l-3.14,6.22.1-7.53a14.22,14.22,0,0,0-4.63-.56,14,14,0,1,0,14.68,13.37Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M934.48,757.13a14,14,0,1,1,.68-11.3L926.39,753l9.65-2.23A14,14,0,0,1,934.48,757.13Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.55,729.88a14,14,0,0,1-4.45-27.53l-.08,5.78,3.18-6.29h0a14,14,0,0,1,14.67,13.36,13.84,13.84,0,0,1-.6,4.79A14,14,0,0,1,927.55,729.88Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M961.62,707.21a14,14,0,1,1,6.21-26.27l-2.48,6.8,5.1-4.9a14,14,0,0,1,4.53,9.69,13.79,13.79,0,0,1-.35,3.87A14,14,0,0,1,961.62,707.21Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M957.62,665.88c-3.24.35-6.39,1.36-9.64,1.56s-6.82-.57-8.88-3.1c-1.1-1.36-1.66-3.08-2.59-4.57a10,10,0,0,0-3.54-3.33,14,14,0,1,0,26.24,9.32Q958.42,665.79,957.62,665.88Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M961.62,707.21a14,14,0,0,1-13.35-20,10.37,10.37,0,0,1,2.82,2.82c1,1.51,1.61,3.26,2.78,4.64,2.19,2.57,5.92,3.41,9.31,3.26s6.66-1.12,10-1.43c.47,0,.94-.07,1.42-.08A14,14,0,0,1,961.62,707.21Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927.55,729.88a14,14,0,0,1-13.46-19.76,11.48,11.48,0,0,1,3,2.85c1.09,1.54,1.77,3.32,3.05,4.74,2.37,2.63,6.35,3.56,9.93,3.48s6.83-.93,10.28-1.2A14,14,0,0,1,927.55,729.88Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M934.48,757.13a14,14,0,0,1-25.59-11.45,13.84,13.84,0,0,1,3.08,2.75c1.34,1.62,2.22,3.47,3.76,5,2.87,2.82,7.5,4,11.63,4.09A60,60,0,0,0,934.48,757.13Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M899.43,777.82s11.08-.34,14.42-2.72,17-5.21,17.86-1.4,16.65,19,4.15,19.06-29.06-1.94-32.4-4S899.43,777.82,899.43,777.82Z",
  transform: "translate(-86 -80.5)",
  fill: "#656380"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M936.08,791.44c-12.51.1-29.06-2-32.39-4-2.54-1.55-3.55-7.09-3.89-9.65h-.37s.7,8.94,4,11,19.89,4.07,32.4,4c3.61,0,4.85-1.31,4.78-3.21C940.14,790.7,938.77,791.41,936.08,791.44Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.2
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.4,795.17c-3-5.51.4-12.27,4.29-17.18s8.61-10,8.51-16.29c-.15-9-9.7-14.31-17.33-19.09a84,84,0,0,1-15.56-12.51,22.8,22.8,0,0,1-4.78-6.4c-1.58-3.52-1.54-7.52-1.44-11.37q.51-19.26,1.91-38.49",
  transform: "translate(-86 -80.5)",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 4
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M105.49,673.14a14,14,0,0,1,7-11.5l3.14,6.22-.1-7.53a14.22,14.22,0,0,1,4.63-.56,14,14,0,1,1-14.68,13.37Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.52,768.13a14,14,0,1,0-.68-11.3l8.77,7.13L129,761.73A14,14,0,0,0,130.52,768.13Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.45,740.88a14,14,0,0,0,4.45-27.53l.08,5.78-3.18-6.29h0a14,14,0,0,0-14.67,13.36,13.84,13.84,0,0,0,.6,4.79A14,14,0,0,0,137.45,740.88Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.38,718.21a14,14,0,1,0-6.21-26.27l2.48,6.8-5.1-4.9A14,14,0,0,0,90,703.53a13.79,13.79,0,0,0,.35,3.87A14,14,0,0,0,103.38,718.21Z",
  transform: "translate(-86 -80.5)",
  fill: "#57b894"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.38,676.88c3.24.35,6.39,1.36,9.64,1.56s6.82-.57,8.88-3.1c1.1-1.36,1.66-3.08,2.59-4.57a10,10,0,0,1,3.54-3.33,14,14,0,1,1-26.24,9.32Q106.58,676.79,107.38,676.88Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.38,718.21a14,14,0,0,0,13.35-20,10.37,10.37,0,0,0-2.82,2.82c-1,1.51-1.61,3.26-2.78,4.64-2.19,2.57-5.92,3.41-9.31,3.26s-6.66-1.12-10-1.43c-.47,0-.94-.07-1.42-.08A14,14,0,0,0,103.38,718.21Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M137.45,740.88a14,14,0,0,0,13.46-19.76,11.48,11.48,0,0,0-3,2.85c-1.09,1.54-1.77,3.32-3,4.74-2.37,2.63-6.35,3.56-9.93,3.48s-6.83-.93-10.28-1.2A14,14,0,0,0,137.45,740.88Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M130.52,768.13a14,14,0,0,0,25.59-11.45,13.84,13.84,0,0,0-3.08,2.75c-1.34,1.62-2.22,3.47-3.76,5-2.87,2.82-7.5,4-11.63,4.09A60,60,0,0,1,130.52,768.13Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.1
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.57,788.82s-11.08-.34-14.42-2.72-17-5.21-17.86-1.4-16.65,19-4.15,19.06,29.06-1.94,32.4-4S165.57,788.82,165.57,788.82Z",
  transform: "translate(-86 -80.5)",
  fill: "#656380"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.92,802.44c12.51.1,29.06-2,32.39-4,2.54-1.55,3.55-7.09,3.89-9.65h.37s-.7,8.94-4,11-19.89,4.07-32.4,4c-3.61,0-4.85-1.31-4.78-3.21C124.86,801.7,126.23,802.41,128.92,802.44Z",
  transform: "translate(-86 -80.5)",
  opacity: 0.2
});

var SvgCreateProject = function SvgCreateProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "fb8df35c-97a2-484c-ac16-3c830d03619c",
    "data-name": "Layer 1",
    width: 1028,
    height: 739,
    viewBox: "0 0 1028 739",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCreateProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/createProject.cbbcaa47.svg";
export { ForwardRef as ReactComponent };